/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Key_Copied_For_RenewalInputs */



/**
* | output |
* | --- |
* | "Your licence key is copied. Paste it at checkout." |
*
* @param {License_Key_Copied_For_RenewalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_key_copied_for_renewal = /** @type {((inputs?: License_Key_Copied_For_RenewalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Key_Copied_For_RenewalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre clé de licence est copiée. Collez-la lors du paiement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Lizenzschlüssel wurde kopiert. Fügen Sie ihn an der Kasse ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La chiave di licenza è stata copiata. Incollala al pagamento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лицензионный ключ скопирован. Вставьте его при оплате.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha copiado tu clave de licencia. Pégala al pagar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已复制许可证密钥。请在结账时粘贴。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスキーをコピーしました。購入手続きで貼り付けてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपकी लाइसेंस कुंजी कॉपी हो गई है। चेकआउट पर इसे पेस्ट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A sua chave de licença foi copiada. Cole-a no pagamento.")
	return /** @type {LocalizedString} */ ("Your licence key is copied. Paste it at checkout.")
});